/**
 * Only the rows band swaps; toolbar/thead/footer stay mounted around this.
 * Distinct from the true "no items yet" case, which redirects to the
 * create page before ever rendering the index page. Shared by CalendarsPage
 * and AlertsPage — was two near-identical copies.
 */
import React, { useMemo } from "react";
import EmptyState from "../../theme/untitled/EmptyState/EmptyState";
import Icon from "../../theme/untitled/icons/Icon";

const NoResultsState = ({ onClear, itemLabelPlural }) => {
  const actions = useMemo(
    () => [{ label: "Clear search and filters", onClick: onClear }],
    [onClear]
  );

  return (
    <EmptyState
      icon={<Icon name="SearchLg" size={24} />}
      title={`No ${itemLabelPlural} match`}
      body={`Try a different search term or clear your filters to see all ${itemLabelPlural}.`}
      actions={actions}
    />
  );
};

export default NoResultsState;
